import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const StarFill = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="StarFill" {...props}>
    <path d="M12.0004 1C12.4305 1.00016 12.8124 1.27553 12.9486 1.68359L15.2211 8.5H22.0004C22.4305 8.50016 22.8124 8.77553 22.9486 9.18359C23.0846 9.59181 22.9441 10.0415 22.6 10.2998L17.1996 14.3496L19.9369 21.6484C20.0933 22.0656 19.9545 22.5368 19.597 22.8027C19.2842 23.0352 18.8697 23.0614 18.5336 22.8838L18.3939 22.7959L12.0004 17.9248L5.60681 22.7959C5.2524 23.0659 4.76133 23.0684 4.40368 22.8027C4.04602 22.5368 3.90736 22.0657 4.06384 21.6484L6.80017 14.3496L1.40075 10.2998C1.05641 10.0415 0.916008 9.59194 1.05212 9.18359C1.18835 8.77547 1.57008 8.5 2.00036 8.5H8.77966L11.0521 1.68359L11.1136 1.53711C11.2839 1.21089 11.6238 1 12.0004 1Z" fill="#000" />
  </StyledIcon>
));

StarFill.displayName = 'StarFill';

export { StarFill };
